import { useContext, useEffect, useState } from "react"
import { BiUser } from "react-icons/bi"
import { toast } from "react-toastify"
import { ModalEstadoContext } from "../../contexts/ModalEstado"
import { criptografarDado } from "../../helpers"
import { RecompensaParams, respostaTicketSuperConectado } from "../../interfaces/recompensa"
import { usuarioConvidados } from "../../interfaces/usuarios"
import { listarConvidados, listarTicketSuperConectado } from "../../services/usuarios"
import { Button } from "../Styles"
import DivSituacao from "../DivSituacao"
import avatarDefault from '../../assets/img/avatarDefault.png'

function ModalDetalhesRecompensa({ recompensa }: RecompensaParams) {

    const { modalExibir } = useContext(ModalEstadoContext)

    const [convidados, setConvidados] = useState<usuarioConvidados[]>([])
    const [tickets, setTickets] = useState<respostaTicketSuperConectado[]>([])

    useEffect(() => {

        if (!recompensa.conquista.titulo.includes("Convite")) return

        const listarUsuariosConvidados = async () => {

            try {

                const payload = {
                    idUsuarioConvite: criptografarDado(recompensa.idUsuarioCreate),
                    valorNivel: recompensa.valorNivel
                }

                const resposta = await listarConvidados(payload)

                setConvidados(resposta.data)
                
            } catch {
                toast.error("Erro ao listar os usuarios convidados.")
            }
        }
        listarUsuariosConvidados()

    }, [recompensa])

    useEffect(() => {

        if (!recompensa.conquista.titulo.includes("Super Conectado")) return

        const buscarTickets = async () => {

            try {

                const resposta = await listarTicketSuperConectado(criptografarDado(recompensa.id.toString()))
                setTickets(resposta.data)

            } catch {
                toast.error("Erro ao listar os tickets.")
            }
        }
        buscarTickets()

    }, [recompensa])

    return (
        <div className="fundoModal">
            <section className="containerModalCentro">
                <span id="novoContainerTitulo">
                    <p>Dados da Recompensa</p>
                </span>
                <form id="formModalNovo">
                    <section>
                        <span>
                            <label>Usuário</label>
                            <input
                                type="text"
                                placeholder="Usuário"
                                value={recompensa.usuario.nome}
                                disabled={true}
                            />
                        </span>
                        <span>
                            <label>Conquista</label>
                            <input
                                type="text"
                                placeholder="Conquista"
                                value={recompensa.conquista.titulo}
                                disabled={true}
                            />
                        </span>
                        <span>
                            <label>Situação</label>
                            <DivSituacao texto={recompensa.situacao} cor={recompensa.situacao.toLowerCase()} />
                        </span>
                    </section>

                    <section>
                        <span>
                            <label>Nível</label>
                            <input
                                type="text"
                                placeholder="Nível"
                                value={recompensa.conquistaNivel.titulo}
                                disabled={true}
                            />
                        </span>
                        <span>
                            <label>Valor do Nível</label>
                            <input
                                type="text"
                                placeholder="Nível"
                                value={recompensa.valorNivel}
                                disabled={true}
                            />
                        </span>
                    </section>
                    <section>
                        <span>
                            <label>Descrição do Nível</label>
                            <textarea
                                placeholder="Nível"
                                value={recompensa.descricaoNivel}
                                disabled={true}
                            />
                        </span>
                    </section>
                    {recompensa.conquista.titulo.includes("Convite") && convidados &&
                        <table style={{ borderSpacing: "0 15px", width: '100%' }}>
                            <thead>
                                <tr>
                                    <th id='ladoEsquerdoContent' align='left'>Usuário</th>
                                    <th align='center'>E-mail</th>
                                </tr>
                            </thead>
                            <tbody>
                                {convidados.map((convidado) => (
                                    <tr key={convidado.id}>
                                        <td align='left' className='primeiraColuna'>
                                            <div className="linhaUsuarioImagem">
                                                {convidado.usuarioConvidadoDados?.avatar ? <img className='usuarioResponsavel' src={convidado.usuarioConvidadoDados.avatar} alt='' /> : <BiUser size={32} />} {convidado.usuarioConvidadoDados.nome}
                                            </div>
                                        </td>
                                        <td align='left' className="ladoDireitoContent">{convidado.usuarioConvidadoDados.email}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    }
                    {recompensa.conquista.titulo.includes("Super Conectado") && tickets &&
                        <table style={{ borderSpacing: "0 15px", width: '100%' }}>
                            <thead>
                                <tr>
                                    <th align="left">Empresa</th>
                                    <th align="left">Atendente</th>
                                    <th align="left">Fila</th>
                                    <th align="left">Data</th>
                                    <th align="left">Situação</th>
                                </tr>
                            </thead>

                            <tbody>
                                {tickets.map(ticket => (
                                    <tr key={ticket.id}>
                                        <td align='left' className='primeiraColuna'>
                                            <div className="linhaUsuarioImagem">
                                                <img className='avatar' src={ticket.organizaco.avatar ? ticket.organizaco.avatar : avatarDefault} alt='' title='Alterar Avatar' width={30} height={30} />
                                                <p>{ticket.organizaco.nomeFantasia}</p>
                                            </div>
                                        </td>
                                        <td>
                                            {ticket?.responsavel ? <div className="linhaUsuarioImagem">
                                                <img className='avatar' src={ticket.responsavel.avatar ? ticket.responsavel.avatar : avatarDefault} alt='' title='Alterar Avatar' width={30} height={30} />
                                                <span>{ticket.responsavel.nome}</span>
                                            </div> : null}
                                        </td>
                                        <td>{ticket?.fila?.titulo}</td>
                                        <td>{new Date(ticket.criado).toLocaleDateString("pt-BR")}</td>
                                        <td><DivSituacao texto={ticket.situacao} cor={ticket.situacao.toLowerCase()} /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    }
                    <span id="botoesContainer">
                        <Button type="button" cor="cancelar" isLoading={false} onClick={() => modalExibir("")}>
                            Fechar
                        </Button>
                    </span>
                </form>
            </section>
        </div>
    )
}

export default ModalDetalhesRecompensa
